import classNames from "classnames"
import React from "react"

import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"

type Props = {
  children: React.ReactNode
}

const Layout = ({ children, ...props }: Props) => {
  return (
    <section
      className="mb-lg md:pt-3xl lg:pt-2xl relative bg-white pt-[60px]"
      {...props}
    >
      <div
        className={classNames(
          "flex min-h-[calc(100vh-68px)] flex-col justify-between pb-[90px] sm:pb-0 md:min-h-[calc(100vh-84px)] lg:min-h-[calc(100vh-108px)]",
          getBackgroundColorClass(Color.LightGray)
        )}
      >
        {children}
      </div>
    </section>
  )
}

export default Layout
